import { useState } from "react";
import { cn } from "@/lib/utils";

interface CustomerLogoProps {
  name: string;
  logoUrl: string | null | undefined;
  className?: string;
}

/**
 * Kundens logo i heroen (v3). Bildet kommer fra customers.logo_url (hentet fra
 * nettsiden av brreg-sync-customers); uten logo, eller når bildet feiler, vises
 * et monogram på lys blå flate.
 */
export default function CustomerLogo({ name, logoUrl, className }: CustomerLogoProps) {
  const [broken, setBroken] = useState(false);
  const monogram = name.trim().charAt(0).toUpperCase() || "?";
  const box = cn("flex h-[72px] w-[72px] shrink-0 items-center justify-center overflow-hidden border-[1.5px] border-foreground", className);
  if (logoUrl && !broken) {
    return (
      <span className={cn(box, "bg-white p-2")}>
        <img src={logoUrl} alt={`Logo ${name}`} className="max-h-full max-w-full object-contain" onError={() => setBroken(true)} />
      </span>
    );
  }
  return (
    <span className={cn(box, "bg-sr-lys-bla font-display text-3xl font-semibold text-foreground")} role="img" aria-label={`Logo ${name}`}>
      {monogram}
    </span>
  );
}
